// util.js

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const fetchData = async (url, options = {}, config = {}) => {
  if (config.useMockData) {
    await delay(500); // Simulate a delay to mimic an actual API call

    const mockResponse = {
      'api-me': {
        ok: true,
        json: () => Promise.resolve(require('./mockup/api-me.json')),
      },
      'api-client-address': {
        ok: true,
        json: () => Promise.resolve(require('./mockup/api-client-address.json')),
      },
      'api-items-json': {
        ok: true,
        json: () => Promise.resolve(require('./mockup/api-items-json.json')),
      },
    };

    const mockData = mockResponse[options.mockData] || null;

    if (mockData) {
      return mockData;
    } else {
      throw new Error(`Mock data not found for URL: ${url}`);
    }
  }

  const response = await fetch(url, options);

  // Handle 403 response by setting local storage flag
  if (response.status >= 400 && response.status < 500) {
    localStorage.setItem('force_bo_refresh', '1');
  }

  return response;
};

export default fetchData;